'use client';

import { PieChart as RechartsChart, Pie, Cell, ResponsiveContainer } from 'recharts';

const COLORS = ['#6464E3', '#FFCE94', '#D64045', '#3DDC97', '#FBCAEF'];

const formatLabel = ({ name, percent }: { name: string; percent: number }) => `${name}: ${(percent * 100).toFixed(1)}%`;

interface PieChartProps {
  data: Array<{
    name: string;
    value: number;
  }>;
}

export const PieChart = ({ data }: PieChartProps) => {
  const shownData = data.filter(d => d.value > 0);
  return (
    <ResponsiveContainer width="100%" height={300}>
      <RechartsChart>
        <Pie
          data={shownData}
          cx="50%"
          cy="50%"
          labelLine
          outerRadius={100}
          fill="#8884d8"
          dataKey="value"
          label={formatLabel}
          style={{ fontSize: '0.85rem' }}
        >
          {shownData.map((_, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
      </RechartsChart>
    </ResponsiveContainer>
  );
};
